import { motion, useReducedMotion } from 'framer-motion'

type Variant = 'gallery' | 'reviews'

export function HomeSectionAmbience({ variant }: { variant: Variant }) {
  const reduced = useReducedMotion()

  if (variant === 'gallery') {
    return (
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-hairline to-transparent opacity-80" />
        <motion.div
          className="absolute -right-[10%] top-[15%] h-[min(40vw,280px)] w-[min(40vw,280px)] rounded-full bg-primary/[0.045] blur-3xl"
          animate={
            reduced
              ? undefined
              : {
                  scale: [1, 1.08, 1],
                  opacity: [0.4, 0.55, 0.4],
                }
          }
          transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
        />
        <svg
          className="absolute bottom-[12%] left-[4%] w-[min(36vw,260px)] text-primary opacity-[0.07]"
          viewBox="0 0 180 160"
          fill="none"
        >
          <path
            d="M20 140c32-24 56-72 52-112s-36-56-68-20 8 96 40 120"
            stroke="currentColor"
            strokeWidth="0.9"
            strokeLinecap="round"
          />
          <circle cx="130" cy="36" r="3" fill="currentColor" opacity={0.35} />
        </svg>
      </div>
    )
  }

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <motion.div
        className="absolute -left-[8%] top-[20%] h-[min(45vw,320px)] w-[min(45vw,320px)] rounded-full bg-primary/[0.05] blur-3xl"
        animate={
          reduced
            ? undefined
            : {
                y: [0, 16, 0],
                opacity: [0.35, 0.5, 0.35],
              }
        }
        transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
      />
      <svg
        className="absolute -right-6 top-[8%] w-[min(42vw,300px)] text-primary opacity-[0.08] md:right-0"
        viewBox="0 0 200 220"
        fill="none"
      >
        <path
          d="M40 200c24-40 16-96-8-136s-56-56-24-48 72 88 88 128 8 88-32 56"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M120 40c16 8 32 32 28 56"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          opacity={0.6}
        />
      </svg>
    </div>
  )
}
